import Ajax from "@/libs/Ajax";
const nameSpace = '/aseapi/console/identitymgr'
export default {
  // 性能优化-查询线程数信息
  queryThread(spuuid) {
    return Ajax.get(`${nameSpace}/queryThread`, {params: {spuuid: spuuid}})
  },
  // 性能优化-保存线程信息
  saveThread(param) {
    return Ajax.post(`${nameSpace}/saveThread`, param)
  },
  // 参数优化-查询
  queryPara() {
    return Ajax.get(`${nameSpace}/queryPara`)
  },
  // 参数优化-保存
  savePara(param) {
    return Ajax.post(`${nameSpace}/savePara`, param)
  },
  getCsSenior(swapuuid) {
    return Ajax.get(`${nameSpace}/getCsSenior/${swapuuid}`)
  },
  getPdSenior(swapuuid) {
    return Ajax.get(`${nameSpace}/getPdSenior/${swapuuid}`)
  },
  doSaveForCsSenior(swapuuid,conf) {
    return Ajax.get(`${nameSpace}/doSaveForCsSenior/`,{ params: { swapuuid: swapuuid, conf: conf } });
  },
  doSaveForPdSenior(swapuuid,conf) {
    return Ajax.get(`${nameSpace}/doSaveForPdSenior/`,{ params: { swapuuid: swapuuid, conf: conf } });
  }
}

